import React from 'react';
import classnames from 'classnames';

import { Modal, SelectableTile, Grid, Row } from '@carbon/react';
import { settings } from 'carbon-components';
import styles from '../FeatureCard/FeatureCard.module.scss';

const { prefix } = settings;

const AddFeature = ({hideModal}) => {
  //const aspectRatio = '1:1';

  const aspectRatioClassNames = (aspectRatio = '1:1') =>
    classnames([`${prefix}--aspect-ratio`], {
      [`${prefix}--aspect-ratio--2x1`]: aspectRatio === '2:1',
      [`${prefix}--aspect-ratio--1x2`]: aspectRatio === '1:2',
      [`${prefix}--aspect-ratio--1x1`]: aspectRatio === '1:1',
      [`${prefix}--aspect-ratio--16x9`]: aspectRatio === '16:9',
      [`${prefix}--aspect-ratio--4x3`]: aspectRatio === '4:3',
    });

  return (
    <Modal
      open={true}
      danger={false}
      size="lg"
      primaryButtonText={'Auswählen'}
      secondaryButtonText={'Abrechen'}
      modalHeading="Feature hinzufügen"
      onRequestClose={hideModal}
      onRequestSubmit={hideModal}
      hasScrollingContent
      className="no-padding-form">
      <Grid>
        <Row>
          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-8">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames('2:1')}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>

          <div className="cds--col-lg-4">
            <figure className={styles.figure} role="group">
              <div className={styles.card}>
                <div className={aspectRatioClassNames()}>
                  <div className={`${prefix}--aspect-ratio--object`}>
                    <SelectableTile style={{ height: '100%' }}>
                      <h4 className={styles.title}>Bundesliga</h4>
                      <h5 className={styles.subtitle}>
                        Super toll diese Bundesliga! mega toll und so
                      </h5>
                    </SelectableTile>
                  </div>
                </div>
              </div>
            </figure>
          </div>
        </Row>
      </Grid>
    </Modal>
  );
};

export default AddFeature;
